import workspaceQuery from '../../../graphql/queries/web/WebPromotionalCodeWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/web/WebPromotionalCodeListQuery.graphql';
import instanceQuery from '../../../graphql/queries/web/WebPromotionalCodeQuery.graphql';
import defaultQuery from '../../../graphql/queries/web/WebPromotionalCodeDefault.graphql';
import mutationQuery from '../../../graphql/mutations/web/WebPromotionalCodeMutation.graphql';
import temporaryMutationQuery from '../../../graphql/mutations/web/WebPromotionalCodeTemporaryMutation.graphql';
import fragment from '../../../graphql/fragments/web/WebPromotionalCodeFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const WebPromotionalCode: EntityType = {
  type: 'WebPromotionalCode',
  title: 'Web Promotional Codes',
  formTitle: 'Web Promotional Code',
  formUrl: '/Web/PromotionalCode/Details/',
  workspaceUrl: '/Web/PromotionalCode/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporaryUpdate: temporaryMutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'WEB_PROMOTIONAL_CODES',
};

export default WebPromotionalCode;
